<template>
  <resource-loader :task="task" :resource="modelValue">
    Post search not found.
  </resource-loader>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  PostSearch,
} from '@/type';
import { HasTaskMixin } from '@/mixins';
import ResourceLoader from '@/components/loading/ResourceLoader.vue';
import repository from './post-search-repository';

interface Data {
  task: Promise<PostSearch>|undefined,
}

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  mixins: [HasTaskMixin],
  components: {
    ResourceLoader,
  },
  props: {
    postSearchId: {
      type: Number,
      required: true,
    },
    modelValue: Object as () => PostSearch,
  },
  data(): Data {
    return {
      task: undefined,
    };
  },
  watch: {
    postSearchId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.find(this.postSearchId);
      this.task.then((postSearch) => {
        this.$emit('update:modelValue', postSearch);
        this.$emit('loaded', postSearch);
      });
    },
  },
});
</script>
